export enum ThemeModeEnum {
  LIGHT = 'light',
  HIGH_CONTRAST_ACCESSIBLE = 'highContrastAccessible',
}
